var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 48a48 48 0 1 1-96 0 48 48 0 0 1 96 0ZM26 29h1a20 20 0 0 1 39 4h6a12 12 0 1 1-1 25l-46-1a14 14 0 0 1 1-28Zm0 46a5 5 0 1 0 8-5c-1-2-8-5-8-5v10Zm49 1c-2 2-5 1-7-1V65s7 3 8 5 1 5-1 6Zm-28-1a5 5 0 1 0 8-5c-1-2-8-5-8-5v10Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainIcon);
export default __webpack_public_path__ + "static/media/rain_icon.ccdfa99a3c9d893dfc88b2aa8a1947cb.svg";
export { ForwardRef as ReactComponent };